import React from 'react';
import { useField, useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const getFieldCSSClasses = (touched, errors) => {
  const classes = ['form-control'];
  if (touched && errors) {
    classes.push('is-invalid');
  }

  if (touched && !errors) {
    classes.push('is-valid');
  }

  return classes.join(' ');
};

const useStyles = makeStyles((theme) => ({
  timeDropdown: {
    width: '100px',
  },
}));

export function DatePickerField({ ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const [field] = useField(props);
  const classes = useStyles();
  return (
    <>
      {props.label && <label>{props.label}</label>}
      <DatePicker
        className={
          getFieldCSSClasses(touched[field.name], errors[field.name]) &&
          classes.timeDropdown
        }
        style={{ width: '100%' }}
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      />
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        <div className="feedback">
          Please enter <b>{props.label}</b> in 'mm/dd/yyyy' format
        </div>
      )}
    </>
  );
}
